const API_ORIGIN_USERCENTER = process.env.VUE_APP_API_ORIGIN_USERCENTER;

export const RESET_PASSWORD = API_ORIGIN_USERCENTER + "/forget/set-password";
export const GET_USER_SECURITIES =
    API_ORIGIN_USERCENTER + "/forget/get-user-security-data";

export const GET_CAPTCHA_FROM_FORGET =
    API_ORIGIN_USERCENTER + "/forget/get-verify-identifer-captcha";
export const VERIFY_ACCOUNT_FROM_FORGET =
    API_ORIGIN_USERCENTER + "/forget/verify-identifer";
export const SEND_VERIFICATION_CODE_FROM_FORGET =
    API_ORIGIN_USERCENTER + "/forget/send-old-<type>-code";
export const VERIFY_VERIFICATION_CODE_FROM_FORGET =
    API_ORIGIN_USERCENTER + "/forget/verify-old-<type>-code";
export const VERIFY_QUESTION_FROM_FORGET =
    API_ORIGIN_USERCENTER + "/forget/verify-qa";

export const GET_HOME_SECURITIES =
    API_ORIGIN_USERCENTER + "/account/get-user-security-data-home";

export const SEND_VERIFICATION_CODE_FROM_PASSWORD_TO_SET_SECURITY =
    API_ORIGIN_USERCENTER + "/account/bind/low-level/send-<type>-code";

export const GET_CAPTCHA_FROM_PASSWORD_TO_SET_SECURITY =
    API_ORIGIN_USERCENTER +
    "/account/bind/low-level/get-verify-password-captcha";

export const VERIFY_PASSWORD_FROM_PASSWORD_TO_SET_SECURITY =
    API_ORIGIN_USERCENTER + "/account/bind/low-level/verify-password";

export const SET_SECURITY_FROM_PASSWORD =
    API_ORIGIN_USERCENTER + "/account/bind/low-level/set-<type>";

export const SEND_VERIFICATION_CODE_FROM_VERIFY_SECURITY =
    API_ORIGIN_USERCENTER + "/account/bind/high-level/send-old-<type>-code";

export const VERIFY_VERIFICATION_CODE_FROM_VERIFY_SECURITY =
    API_ORIGIN_USERCENTER + "/account/bind/high-level/verify-old-<type>-code";

export const VERIFY_QUESTION_FROM_VERIFY_SECURITY =
    API_ORIGIN_USERCENTER + "/account/bind/high-level/verify-qa";

export const SEND_VERIFICATION_CODE_FROM_SET_SECURITY =
    API_ORIGIN_USERCENTER + "/account/bind/high-level/send-<type>-code";

export const SET_SECURITY_FROM_SECURITY =
    API_ORIGIN_USERCENTER + "/account/bind/high-level/set-<type>";
